import { UIComponent } from '@/components/core/components';
import { Button, Image } from '@/components/core';
import { Trans } from '@lingui/react/macro';
import * as styles from './motenization.styles';
import Subtitle from '../subtitle';

const Monetization: UIComponent = () => {
  return (
    <section className={styles.root}>
      <div className={styles.content}>
        <Subtitle className={styles.title}>Peoople Money Maker</Subtitle>
        <p>
          <Trans>
            <b>Earn money as an influencer</b>, regardless of your experience, and get it in real-time from your Wallet, with the option to transfer
            it to your bank account.
          </Trans>
        </p>
        <p>
          <Trans>
            <b>Get rewards</b> through challenges, recommendations, invitations, and more!
          </Trans>
        </p>
        <Button href="https://moneymaker.peoople.app/" as="a" rel="noopner nofollow" target="_blank">
          <Trans>Learn more</Trans>
        </Button>
      </div>
      <div>
        <Image width="100%" alt="Peoople Money Maker" src="/peoople-money-maker.png" />
      </div>
    </section>
  );
};

export default Monetization;
